import { FC } from 'react';
import styled from 'styled-components';
import GradientBar, { GradientVariation } from '../GradientBar/GradientBar';

const MainLayoutElement = styled.div<Pick<IProps, 'displayGradient'>>`
  display: grid;
  grid-template-areas: 'navigation main';
  grid-template-columns: auto 1fr;
  height: 100vh;
  overflow: hidden;
  padding-top: ${({ displayGradient }) => (displayGradient ? '0.5rem' : 0)};
  width: 100vw;
`;

export interface IProps {
  /** Display Gradient across the top of the page */
  displayGradient?: boolean;
  /** Variation of the gradient bar */
  gradientVariation?: GradientVariation;
}

export const MainLayout: FC<IProps> = ({ displayGradient, gradientVariation, children }) => (
  <MainLayoutElement data-testid="MainLayout" displayGradient={displayGradient}>
    {displayGradient && <GradientBar variation={gradientVariation} />}

    {children}
  </MainLayoutElement>
);
